import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http'
import { Constant } from '../../../environments/constants';
import { Utils } from '../../../utils/utils';


@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(private http: HttpClient) { }

  searchClients(searchText?:string) {
    if(searchText){
      return this.http.get(encodeURI(Constant.uri.cosmosclientsearchapi+'?search='+ searchText +'*&' + Constant.searchQuery.clientSearchWithSearchText), Utils.getHttpOptions());
    } else {
      return this.http.get(encodeURI(Constant.uri.cosmosclientsearchapi+'?'+ Constant.searchQuery.clientSearch), Utils.getHttpOptions());
    }   
  }

  searchMoreClients() {
    return this.http.get(encodeURI(Constant.uri.cosmosclientsearchapi+'?'+ Constant.searchQuery.clientSearchMore), Utils.getHttpOptions());    
  }

  searchAccounts(searchText:string) {
    if(searchText){
      return this.http.get(encodeURI(Constant.uri.cosmosaccountsearchapi+'?search='+ searchText +'*&' + Constant.searchQuery.accountSearchWithSearchText), Utils.getHttpOptions());
    } else {
      return this.http.get(encodeURI(Constant.uri.cosmosaccountsearchapi+'?'+ Constant.searchQuery.accountSearch), Utils.getHttpOptions());
    }   
  }

  searchSecurity(searchText:string) {
    let searchCriteria = {
      count:true,
      searchMode: "any",
      search: searchText,
      //searchFields: "symbol, cusip",
      select: "symbol, cusip, invType, secName, secType",
      top: 5
    };

    return this.http.post(Constant.uri.securitymastersearch, searchCriteria, Utils.getHttpOptions());        
  }

  searchSecurityByCusip(searchText:string) {
    let searchCriteria = {
      count:true,
      searchMode: "any",
      search: searchText,
      searchFields: "cusip",
      select: "symbol, cusip, invType, secName, secType",
      top: 5
    };

    return this.http.post(Constant.uri.securitymastersearch, searchCriteria, Utils.getHttpOptions());        
  }

  getSecurities(sybmols: string){
    let searchCriteria = {
      count:true,
      filter: "search.in(cusip,'" + sybmols.toUpperCase() + "') or search.in(symbol,'" + sybmols.toUpperCase() + "')"
    };

    return this.http.post(Constant.uri.securitymastersearch, searchCriteria, Utils.getHttpOptions());  
  }
  
}
